import { validateTidalLicense } from "../../base/index.js";
import { repeat } from "./repeat.js";
function padRight(str, minLen, ch = " ") {
  return str.length < minLen ? str + repeat(ch, minLen - str.length) : str;
}
validateTidalLicense();
export {
  padRight
};
//# sourceMappingURL=padRight.js.map
